import React, { FormEvent, useState } from "react";
import { api, CompanyEmployeeRoleDto } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Error, Input, LoadingDots, Modal } from "shared/ui";

export interface IRoleRenameModal extends UseModalProps {
  companySlug: string;
  data: CompanyEmployeeRoleDto;
}

export const RoleRenameModal = (props: IRoleRenameModal) => {
  const submit = useApiMethod(api.companyRbac.companyEmployeeRoleChangeName);

  const [name, setName] = useState<string>(props.data.name);

  const valid = !!name.trim();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!name) return;

    await submit.call(props.companySlug, props.data.id, { name });
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={400}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Название роли</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Input autoFocus placeholder="Название роли" value={name} onChange={(e) => setName(e.target.value)} />

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Назад
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading || !valid}>
            {!submit.loading ? "Сохранить" : <LoadingDots size={4}>Сохраняем</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

RoleRenameModal.defaultProps = {};
